export enum IRole {
    ADMIN = "ADMIN",
    COMPANY = "COMPANY",
    MANAGER = "MANAGER",
    RECEPTIONIST = "RECEPTIONIST",
    TECHNICIAN = "TECHNICIAN",
    FAVORITE = "FAVORITE"
}
// enum('ADMIN', 'COMPANY', 'RECEPTIONIST', 'MANAGER', 'TECHNICIAN')

export enum IRoleName {
    ADMIN = "admin",
    COMPANY = "company",
    MANAGER = "manager",
    RECEPTIONIST = "receptionist",
    TECHNICIAN = "technician",
    FAVORITE = "favorite" 
}

export interface InRole {
    id: number,
    name: string
    code: 'ADMIN' | 'COMPANY' | 'RECEPTIONIST' | 'MANAGER' | 'TECHNICIAN' | 'FAVORITE' | ''
}